export default __webpack_public_path__ + "static/media/caribbeanportatetable.bfc9dfee.webp";